var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDhlBarcodeOnBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 71,
    viewBox: "0 0 94 71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#FFCC01",
    strokeWidth: 1.3,
    fill: "#FFF",
    x: 0.65,
    y: 0.65,
    width: 92.7,
    height: 69.7,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 8v55h-8.478V8H86zM73.283 8v55h-4.24V8h4.24zm-5.935 0v55h-1.696V8h1.696zm-3.391 0v55H62.26V8h1.696zm-3.392 0v55H58.87V8h1.695zm-3.391 0v55h-5.087V8h5.087zm-7.63 0v55h-1.696V8h1.695zm-3.392 0v55h-1.695V8h1.695zm-5.087 0v55h-6.782V8h6.782zM31.74 8v55h-5.087V8h5.087zm-8.478 0v55h-1.696V8h1.696zM19.87 8v55h-3.392V8h3.392zm-5.087 0v55H8V8h6.783z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhlBarcodeOnBtn);
export default __webpack_public_path__ + "static/media/dhl_barcode_on_btn.3bd551341c813fad7c6f9b3b573aab1e.svg";
export { ForwardRef as ReactComponent };